import { CompanyUserPermissions } from "../types/userTypes";

const TABS_ACCESS_KEYS = {
  [CompanyUserPermissions.turnovers]: "turnover",
  [CompanyUserPermissions.reports]: "visitors",
};

const CLIENT_TABS_ACCESS_KEYS = {
  [CompanyUserPermissions.invoices]: "invoices",
  [CompanyUserPermissions.requests]: "requests",
  [CompanyUserPermissions.incidents]: "incidents",
  [CompanyUserPermissions.reports]: "reports",
  [CompanyUserPermissions.visitorsReports]: "reports",
  [CompanyUserPermissions.contacts]: "contacts",
};

const ALL_ACCESS = ["contracts", "consumer_price_index_cpi", "reports"];
const CLIENT_ALL_ACCESS = ["my_lease", "home", "announcements"];

export const filterTabs = (items, permissions: CompanyUserPermissions[]) => {
  const hasAccessTo = permissions?.map(
    permisison => TABS_ACCESS_KEYS[permisison]
  );
  return items?.filter(
    item => hasAccessTo?.includes(item.name) || ALL_ACCESS.includes(item.name)
  );
};

export const filterClientTabs = (
  items,
  permissions: CompanyUserPermissions[]
) => {
  const hasAccessTo = permissions?.map(
    permission => CLIENT_TABS_ACCESS_KEYS[permission]
  );

  const hasRequestsOrIncidents =
    permissions?.includes(CompanyUserPermissions.requests) ||
    permissions?.includes(CompanyUserPermissions.incidents);

  return items?.filter(
    item =>
      CLIENT_ALL_ACCESS.includes(item.name) ||
      hasAccessTo?.includes(item.name) ||
      (item.name === "requests" && hasRequestsOrIncidents)
  );
};
